const UIElementAttributes = {
  name: 'name',
  disabled: 'disabled',
};

const buttonAttributes = {
  ...UIElementAttributes,
  caption: 'caption',
  icon: 'icon',
};

const checkBoxAttributes = {
  ...UIElementAttributes,
  caption: 'caption',
};

const counterAttributes = {
  ...UIElementAttributes,
  minValue: 'min-value',
  maxValue: 'max-value',
  step: 'step',
};

const datePickerAttributes = {
  ...UIElementAttributes,
  placeholder: 'placeholder',
  minDate: 'min-date',
};

const labelAttributes = {
  ...UIElementAttributes,
  text: 'text',
  hint: 'hint',
};

const messageAttributes = {
  ...UIElementAttributes,
  type: 'type',
};

const radioButtonsAttributes = {
  ...UIElementAttributes,
  buttons: 'buttons',
};

const selectAttributes = {
  ...UIElementAttributes,
  searchable: 'searchable',
  multiSelect: 'multi-select',
  placeholder: 'placeholder',
  items: 'items',
};

const fontFamilySelectAttributes = {
  ...selectAttributes,
  addCustomFontOption: 'add-custom-font-option',
};

const selectItemAttributes = {
  ...UIElementAttributes,
  text: 'text',
  value: 'value',
};

const checkItemAttributes = {
  ...UIElementAttributes,
  text: 'text',
  hint: 'hint',
  icon: 'icon',
  value: 'value',
};

const checkButtonsAttributes = {
  ...UIElementAttributes,
  buttons: 'buttons',
};

const radioItemAttributes = {
  ...UIElementAttributes,
  text: 'text',
  hint: 'hint',
  icon: 'icon',
  value: 'value',
};

const textAttributes = {
  ...UIElementAttributes,
  placeholder: 'placeholder',
};

const textAreaAttributes = {
  ...UIElementAttributes,
  resizable: 'resizable',
  placeholder: 'placeholder',
};

const iconAttributes = {
  ...UIElementAttributes,
  img: 'img',
  src: 'src',
  title: 'title',
  imageClass: 'image-class',
  hint: 'hint',
  disabled: 'disabled',
  isActive: 'is-active',
  visibility: 'visibility',
  transform: 'transform',
};

const nestedControlAttributes = {
  ...UIElementAttributes,
  controlId: 'control-id',
};

const expandableAttributes = {
  ...UIElementAttributes,
  expanded: 'expanded',
};

const orderableAttributes = {
  ...UIElementAttributes,
  icon: 'icon',
  position: 'position',
};

const orderableItemAttributes = {
  ...UIElementAttributes,
};

const orderableIconAttributes = {
  ...UIElementAttributes,
  icon: 'icon',
};

const repeatableAttributes = {
  ...UIElementAttributes,
};

const draggableBlockAttributes = {
  ...UIElementAttributes,
  blockId: 'block-id',
};

const ampFormServicePickerAttributes = {
  ...UIElementAttributes,
};

const MultipleSelectAttributes = {
  ...UIElementAttributes,
  placeholder: 'placeholder',
};

/**
 * @description List of attributes supported by corresponding UI Element ({@link UIElementType}).
 */
export const UEAttr = {
  DEFAULT: UIElementAttributes,
  BUTTON: buttonAttributes,
  CHECKBOX: checkBoxAttributes,
  CHECK_BUTTONS: checkButtonsAttributes,
  COLOR: UIElementAttributes,
  COUNTER: counterAttributes,
  DATEPICKER: datePickerAttributes,
  LABEL: labelAttributes,
  MESSAGE: messageAttributes,
  RADIO_BUTTONS: radioButtonsAttributes,
  SELECTPICKER: selectAttributes,
  FONT_FAMILY_SELECT: fontFamilySelectAttributes,
  SWITCHER: UIElementAttributes,
  TEXT: textAttributes,
  TEXTAREA: textAreaAttributes,
  ICON: iconAttributes,
  CHECK_ITEM: checkItemAttributes,
  SELECT_ITEM: selectItemAttributes,
  RADIO_ITEM: radioItemAttributes,
  NESTED_CONTROL: nestedControlAttributes,
  EXPANDABLE: expandableAttributes,
  ORDERABLE: orderableAttributes,
  ORDERABLE_ITEM: orderableItemAttributes,
  ORDERABLE_ICON: orderableIconAttributes,
  REPEATABLE: repeatableAttributes,
  DRAGGABLE_BLOCK: draggableBlockAttributes,
  AMP_FORM_SERVICE_PICKER: ampFormServicePickerAttributes,
  MULTIPLE_SELECT: MultipleSelectAttributes,
};
